export default class RavenConfigurationDataSource {

    constructor(mqttService) {
        this.mqttService = mqttService;
        this.changeListeners = [];
        this.displayConfiguration = null;
    }

    changeScreens(displayLeft, displayRight) {
        const [ screenGroup1, ...otherScreenGroups ]  = this.displayConfiguration.screenGroups;
        const request = {
            displayConfiguration: {
                activeGroupName: {value: "1"},
                screenGroups: [
                    { ...screenGroup1, name: "1", leftWidget: displayLeft, rightWidget: displayRight, order: 0 },
                    ...otherScreenGroups
                ]
            }
        };
        return this.mqttService.sendConfigurationRequest({ request })
            .then(() => {
                this.displayConfiguration.activeGroupName = request.displayConfiguration.activeGroupName;
                this.displayConfiguration.screenGroups[0] = request.displayConfiguration.screenGroups[0];
                this.notifyChangeListeners();
            });
    }

    getDisplayConfiguration() {
        if(this.displayConfiguration) {
            return Promise.resolve(this.displayConfiguration)
                .then(config => {
                    return {
                        displayLeft: config.screenGroups[0].leftWidget,
                        displayRight: config.screenGroups[0].rightWidget,
                    }
                });
        } else {
            return this.mqttService.sendConfigurationQuery()
                .then(response => {
                    if(!response.queryResponse) throw Error("not a valid queryResponse");
                    if(!response.queryResponse.configurationResponse.displayConfiguration) throw Error("no displayConfiguration returned");
                    this.displayConfiguration = response.queryResponse.configurationResponse.displayConfiguration;
                    return this.displayConfiguration;
                }).then(config => {
                    return {
                        displayLeft: config.screenGroups[0].leftWidget,
                        displayRight: config.screenGroups[0].rightWidget,
                    }
                });
        }
    }

    startListeningForChanges(onChange) {
        if(!this.changeListeners.includes(onChange)) {
            this.changeListeners.push(onChange);
        }
    }

    stopListeningForChanges(onChange) {
        if(this.changeListeners.includes(onChange)) {
            this.changeListeners.remove(onChange);
        }
    }

    notifyChangeListeners() {
        this.changeListeners.forEach(onChange => {
            onChange();
        });
    }
}
